import { CountUp } from "@/components/CountUp";
import { iconColorMap, statDefs } from "@/components/StatCards.styles";
import { cn } from "@/lib/utils";
import * as shared from "@/styles/shared";
import type { StatCardsProps } from "@/types/statCards";
import { buildStatCardValues } from "@shared/analytics";

const StatCards = ({ summary, formatCurrency, t, styles, animationDelay = true }: StatCardsProps) => {
  if (!summary) return null;

  const values = buildStatCardValues(summary, formatCurrency);

  const statCards = statDefs.map((def) => {
    const colors = iconColorMap[def.iconGradient] ?? { bg: "bg-muted", text: "text-muted-foreground", ring: "ring-transparent" };
    const match = values.find((v) => v.labelKey === def.labelKey);
    return { ...def, colors, value: match?.value ?? "—", raw: match?.raw ?? 0 };
  });

  return (
    <div className={cn(styles.statsGrid, styles.pageEnter)}>
      {statCards.map((stat, index) => (
        <div
          key={stat.labelKey}
          className={cn(styles.statCardWrapper, stat.colors.ring, animationDelay && shared.animateSlideUp)}
          style={animationDelay ? { animationDelay: `${index * 50}ms` } : undefined}
        >
          <div className={shared.rowGap3}>
            <div className={cn(styles.statIconWrapper, stat.colors.bg)}>
              <stat.icon className="h-5 w-5" />
            </div>
            <div className={styles.statInfo}>
              <p className={styles.statLabel}>{t(stat.labelKey)}</p>
              <p className={cn(styles.statValue, stat.colors.text)}>
                <CountUp value={stat.raw} format={stat.isCurrency ? formatCurrency : (n) => String(Math.round(n))} />
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export { StatCards };
